import { render, staticRenderFns } from "./HospitalDischarge.vue?vue&type=template&id=8b40ea5e"
import script from "./HospitalDischarge.vue?vue&type=script&lang=js"
export * from "./HospitalDischarge.vue?vue&type=script&lang=js"
import style0 from "./HospitalDischarge.vue?vue&type=style&index=0&id=8b40ea5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports